import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseComponent } from '../../base/base.component';
import { AdminAuditLogConfig } from 'projects/angular-clarity/src/app/stores/client/powershell/exo/admin-audit-log-config/model';

@Component({
    selector: 'app-baseline',
    templateUrl: './baseline.component.html',
    styleUrls: ['./baseline.component.scss', '../../styles/baseline-style.scss'],
})
export class BaselineComponent extends BaseComponent implements OnInit {
    @Input() data: AdminAuditLogConfig;
    ngOnInit(): void {
        const schema = JSON.parse(JSON.stringify(this.baseline.schema));

        const value = schema.properties?.UnifiedAuditLogIngestionEnabled?.const;

        if (value !== undefined) {
            this.control.setValue(value);
        } else {
            this.control.setValue('any');
        }

        this.control.valueChanges.subscribe((value) => {
            if (value === 'any') {
                delete schema.properties?.UnifiedAuditLogIngestionEnabled?.const;
                schema.required = [];
            } else {
                schema.properties.UnifiedAuditLogIngestionEnabled['const'] = value;
                schema.required = ['UnifiedAuditLogIngestionEnabled'];
            }

            this.baselineChange.next({
                ...this.baseline,
                schema: JSON.parse(JSON.stringify(schema)),
            });
        });
    }
}
